// extracted by mini-css-extract-plugin
module.exports = {"popup":"AuthInfoPopup_popup__2W5GV","link":"AuthInfoPopup_link__3kxjr"};